// Azai Studios brand colors - matching CSS variables from azaistudios.com
export const COLORS = {
  // Primary brand colors
  orange: '#ff6422', // --azai-pop
  black: '#191919', // --azai-black
  darkBg: '#2a2a2a', // --azai-grey
  white: '#ffffff', // --azai-white
  offWhite: '#fbfbfb', // --azai-light-grey
  gray: '#6b7280', // Slightly darker for better readability
  grayLight: '#939393', // --light-grey-secondary (for less important text)
  lightGray: '#e5e7eb',
  neutralBlack: '#000000', // --azai-neutral-black
  transparent: 'transparent',
};

// CSS Variables for easy reference
export const CSS_VARS = {
  radiusBase: '0.5rem', // --radius--base
  radius125: '1.25rem', // --radius--1-25
  radius625: '0.625rem', // --radius--625
  radius3125: '0.3125rem', // --radius--3125
};

// Font definitions - matching Azai Studios (all PP Telegraf)
// Fallback stack: SF Pro (iOS/macOS), Segoe UI (Windows), Roboto (Android), then system defaults
export const FONTS = {
  headline: '"PP Telegraf", sans-serif',
  body: '"PP Telegraf", sans-serif',
};

// =============================================================================
// TYPOGRAPHY SCALE
// A systematic type scale for clear visual hierarchy
// =============================================================================
export const TYPE = {
  // Display - Page titles, hero text, big numbers
  display: {
    size: 'clamp(1.75rem, 4vw, 2.5rem)', // 28px → 40px
    lineHeight: 1.1,
    weight: 400,
  },
  // H2 - Section titles
  h2: {
    size: 'clamp(1.25rem, 2.5vw, 1.625rem)', // 20px → 26px
    lineHeight: 1.2,
    weight: 400,
  },
  // H3 - Card titles, subsections
  h3: {
    size: '1.125rem', // 18px
    lineHeight: 1.3,
    weight: 500,
  },
  // H4 - Small headings, tier names
  h4: {
    size: '1rem', // 16px
    lineHeight: 1.4,
    weight: 500,
  },
  // Body - Primary content, form values
  body: {
    size: '0.9375rem', // 15px
    lineHeight: 1.5,
    weight: 400,
  },
  // Label - Form labels, dropdown labels
  label: {
    size: '0.8125rem', // 13px
    lineHeight: 1.4,
    weight: 400,
  },
  // Small - Descriptions, hints, captions
  small: {
    size: '0.75rem', // 12px
    lineHeight: 1.5,
    weight: 400,
  },
  // Micro - Badges, uppercase eyebrows
  micro: {
    size: '0.6875rem', // 11px
    lineHeight: 1.3,
    weight: 500,
  },
};

// =============================================================================
// SPACING SCALE
// Based on 8px grid for consistent rhythm
// =============================================================================
export const SPACE = {
  xs: '0.25rem',   // 4px - Tight gaps (icon to text)
  sm: '0.5rem',    // 8px - Small gaps between related items
  md: '1rem',      // 16px - Standard gap between form fields
  lg: '1.5rem',    // 24px - Card internal padding
  xl: '2rem',      // 32px - Between major sections
  '2xl': '3rem',   // 48px - Top-level section separation
};

// Card padding - consistent across light and dark themes
export const CARD = {
  padding: {
    desktop: '1.5rem', // 24px
    mobile: '1.25rem', // 20px
  },
  gap: '1rem', // 16px between elements inside cards
  radius: '0.625rem', // 10px
};

// Form element sizing
export const FORM = {
  inputPadding: '0.875rem 1rem', // 14px 16px
  inputRadius: '0.5rem', // 8px
  labelMargin: '0.5rem', // 8px below label
  fieldGap: '1.25rem', // 20px between form fields
};
